import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { isUndefined } from 'lodash'
import { fetchSystemLogs, updateSystemLog } from 'src/Libs/installations/api/installation.api'
import { SystemlogType } from 'src/Libs/installations/types'
import { getUnresolvedSmartMeterGatewayLogIds, SMART_METER_GATEWAY_LOG_ERROR_CODE } from '../functions'

// open smart meter gateway logs per device are expected to be far below this
const SMART_METER_GATEWAY_LOGS_LIMIT = 100

interface UseResolveSmartMeterGatewayLogsHook {
  resolveSmartMeterGatewayLogs: (deviceLinkId: number | undefined) => Promise<void>
}

/**
 * Resolves the open smart meter gateway logs of a device link.
 * The backend doesn't resolve them after the smart meter gateway SKI is trusted, so the portal does it.
 */
export const useResolveSmartMeterGatewayLogs = (installationId: number | undefined): UseResolveSmartMeterGatewayLogsHook => {
  const authFetch = useAuthFetchWithResponse()

  const resolveSmartMeterGatewayLogs = async (deviceLinkId: number | undefined): Promise<void> => {
    if (isUndefined(installationId) || isUndefined(deviceLinkId)) {
      return
    }

    const logs = await fetchSystemLogs(
      installationId,
      {
        filter: `errorType:IN(${SystemlogType.Notice}) AND errorCode:IN(${SMART_METER_GATEWAY_LOG_ERROR_CODE}) AND isResolved:IN(0) AND deviceLinkId:IN(${deviceLinkId})`,
        sort: '-createdAt',
        limit: SMART_METER_GATEWAY_LOGS_LIMIT,
        offset: 0,
      },
      authFetch
    )

    await Promise.all(getUnresolvedSmartMeterGatewayLogIds(logs).map(id => updateSystemLog(installationId, { id }, authFetch)))
  }

  return { resolveSmartMeterGatewayLogs }
}
